/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const fontFamily = "\"Lab Grotesque\", sans-serif";
/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const fontWeight = "400";
/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const textTransform = "none";
/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const fontSize = "14px";
/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const letterSpacing = "0px";
/* typography/Desktop/Body/14 Reg - Small/Red - Right aligned */
export const lineHeight = "20px";
export const align = "top";
export const iconInfoColor = "rgb(86, 111, 184)";
export const iconInfoGlyph = "dls-icon-lightbulb-small";
export const iconInvalidColor = "rgb(247, 96, 86)";
export const iconInvalidGlyph = "dls-icon-circle-exclamation-small";
export const iconNormalColor = "rgb(112, 111, 110)";
export const iconValidColor = "rgb(123, 201, 157)";
export const iconValidGlyph = "dls-icon-check-small";
export const messageInfoTextColor = "rgb(112, 111, 110)";
export const messageInvalidTextColor = "rgb(209, 53, 42)";
export const messageNormalTextColor = "rgb(112, 111, 110)";
export const messageTypographyStyle = "dls-typography-desktop-body-reg-small";
export const messageValidTextColor = "rgb(112, 111, 110)";
export const position = "left";
export const space = "mini";